<header
	*ngIf="navbar; else noNavbar"
	obg-m-navbar
	(back)="close()"
	[options]="navbarOptions"
	[titleText]="titleText"
></header>
<ng-template #noNavbar>
	<span *ngIf="titleText" mat-dialog-title [innerHtml]="titleText | translate"></span>
	<button
		*ngIf="isDialog && !hideClose"
		mat-icon-button
		tabindex="-1"
		test-id="modal-close"
		data-test-id="modal-close"
		(click)="onCloseIconClick()"
	>
		<span class="ico-close"></span>
	</button>
</ng-template>

<div class="obg-m-dialog-content" cdkScrollable>
	<p *ngIf="descriptionText" class="obg-m-dialog-content-description">{{ descriptionText | translate }}</p>
	<obg-m-overlay-spinner *ngIf="loading" [message]="loadingMessage" [dialog]="isDialog"></obg-m-overlay-spinner>
	<ng-content></ng-content>
</div>

<ng-container *ngTemplateOutlet="customFooterTemplate || defaultTemplate"></ng-container>

<ng-template #defaultTemplate>
	<obg-compact-footer *ngIf="!hideFooter" [showJurisdictionLicenseLogo]="true"></obg-compact-footer>
</ng-template>
